<template>
  <div v-if="document_person_data.person!=null">
    <CRow>
      <CCol md="12">
        <CCardHeader class="p-1">
          <CRow>
            <CCol col="5" style="text-align: center ;padding:10px 20px 0 20px ">

            </CCol>
            <CCol col="2" style="text-align: center ;padding:10px 20px 0 20px ">
<!--              <h6 style="font-weight: bold;" v-if="selectedType==7">{{ $t('buyFactorCurrency') }}</h6>-->
<!--              <h6 style="font-weight: bold;" v-if="selectedType==1">{{ $t('components.buyDocument') }}</h6>-->
<!--              <h6 style="font-weight: bold;" v-if="selectedType==3">{{ $t('Sales') }}</h6>-->

            </CCol>
            <CCol col="5" style="text-align: end">
              <CRow style="justify-content: end;margin:0px">
                <CButton v-if="doc_status==0" @click="finalize(true)" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('savePrint') }}
                </CButton>
                <CButton v-if="doc_status==0" @click="finalize(false)" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('save') }}
                </CButton>


                <CButton
                    @click="print_with_header_title_height('printMe','print_report_header','print_report_footer',doc_id_no,300,350)"
                    size="sm"
                    v-if="get_access('sale_hide_tax_off')"

                    color="secondary"
                    class="mr-1">
                  {{ $t('buttons.print') }}
                </CButton>
                <CDropdown
                    size="sm"
                    class="mr-1"
                    v-if="!get_access('sale_hide_tax_off')"
                    style="width: 100px"
                    color="secondary"
                    :toggler-text="$t('buttons.print')"
                >
                  <CDropdownItem
                      @click="print_with_header_title_height('printMe','print_report_header','print_report_footer',doc_id_no,300,320)"
                  >{{ $t('printA4Full') }}
                  </CDropdownItem>

                  <CDropdownItem
                      v-if="get_access('a4_print')"
                      @click="print_with_header_title_height('printMeLow','print_report_header_low','print_report_footer',doc_id_no,300,320)"
                  >{{ $t('printA4') }}
                  </CDropdownItem>

                  <CDropdownItem
                      @click="print_element('printThermal',doc_id_no)"
                  >{{ $t('ThermalPrint') }}
                  </CDropdownItem>

                </CDropdown>
                <CButton
                    @click="get_email_html('printMe','print_report_header','print_report_footer',person_email,doc_id_no)"
                    size="sm"
                    color="secondary"
                    class="mr-1">

                  {{ $t('email') }}
                </CButton>
                <CButton v-if="doc_status==0" @click="delete_item_dialog()" size="sm"
                         color="secondary"
                         class="mr-1">

                  {{ $t('buttons.delete') }}
                </CButton>
                <CButton v-if="doc_status==0" @click="goEdit()" size="sm"
                         color="secondary"
                         class="mr-1">
                  {{ $t('buttons.edit') }}
                </CButton>
              </CRow>

              <!--              <CButton-->
              <!--                  @click="print_with_header_title_height('printMe','print_report_header','print_report_footer',doc_id_no,300)"-->

              <!--                  size="sm"-->
              <!--                  color="secondary"-->
              <!--                  class="mr-1">-->

              <!--                {{ $t('buttons.print') }}-->
              <!--              </CButton>-->
              <!--              <CButton-->
              <!--                  @click="print_element('printThermal')"-->

              <!--                  size="sm"-->
              <!--                  color="secondary"-->
              <!--                  class="mr-1">-->

              <!--                {{$t('ThermalPrint')}}-->
              <!--              </CButton>-->

            </CCol>
          </CRow>
        </CCardHeader>
        <div id="print_report_footer" v-show="false">

          <div style="width: 100%;">
            <CCardHeader>
<!--              <CRow>-->
<!--                <CCol col="7" style="text-align: start;border: 1px solid #d8dbe0">-->

<!--                  <p class="mb-1" style="text-align: start" v-for="(message,index) in messages_items">{{-->
<!--                      message.message-->
<!--                    }}</p>-->
<!--                  <br>-->

<!--                  <div style="bottom: 0;position: absolute;width: 100%;">-->
<!--                    <p class="mb-1">{{ $t('weightOfInvoice') }} {{ get_weight(total_weight) }} {{ $t('kg') }}</p>-->
<!--                  </div>-->
<!--                </CCol>-->
<!--                <CCol col="5">-->

<!--                  <CDataTable v-if="selectedType!=7"-->
<!--                              :items="document_result_price"-->
<!--                              :fields="fields_total_price"-->
<!--                              striped-->
<!--                              border-->
<!--                              :responsive="false"-->
<!--                              :items-per-page="200"-->
<!--                              hover-->
<!--                              pagination-->
<!--                  >-->
<!--                    <template #resultTitle="{item}">-->

<!--                      <td v-if="item.final_price" class="text-danger">-->
<!--                        <strong>{{ item.resultTitle }}</strong>-->
<!--                      </td>-->
<!--                      <td v-else>-->
<!--                        <strong>{{ item.resultTitle }}</strong>-->
<!--                      </td>-->


<!--                    </template>-->
<!--                    <template #resultPrice="{item}">-->

<!--                      <td style="text-align: right" v-if="item.final_price" class="text-danger">-->
<!--                        &lt;!&ndash;                                          <strong > {{currency_with_symbol()}}</strong>&ndash;&gt;-->
<!--                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>-->
<!--                      </td>-->
<!--                      <td style="text-align: right" v-else>-->
<!--                        &lt;!&ndash;                                          <strong > {{currency_symbol()}}</strong>&ndash;&gt;-->
<!--                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>-->
<!--                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>-->
<!--                      </td>-->

<!--                    </template>-->

<!--                  </CDataTable>-->
<!--                  <CDataTable v-if="selectedType==7"-->
<!--                              :items="document_result_price"-->
<!--                              :fields="fields_total_price_currency"-->
<!--                              striped-->
<!--                              border-->
<!--                              :responsive="false"-->
<!--                              :items-per-page="200"-->
<!--                              hover-->
<!--                              pagination-->
<!--                  >-->
<!--                    <template #resultTitle="{item}">-->

<!--                      <td v-if="item.final_price" class="text-danger">-->
<!--                        <strong>{{ item.resultTitle }}</strong>-->
<!--                      </td>-->
<!--                      <td v-else>-->
<!--                        <strong>{{ item.resultTitle }}</strong>-->
<!--                      </td>-->


<!--                    </template>-->
<!--                    <template #resultPrice="{item}">-->

<!--                      <td style="text-align: right" v-if="item.final_price" class="text-danger">-->
<!--                        &lt;!&ndash;                                          <strong > {{currency_with_symbol()}}</strong>&ndash;&gt;-->
<!--                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>-->
<!--                      </td>-->
<!--                      <td style="text-align: right" v-else>-->
<!--                        &lt;!&ndash;                                          <strong > {{currency_symbol()}}</strong>&ndash;&gt;-->
<!--                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>-->
<!--                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>-->
<!--                      </td>-->

<!--                    </template>-->
<!--                    <template #resultPriceCurrency="{item}">-->
<!--                      <td style="text-align: right" v-if="item.final_price" class="text-danger">-->
<!--                        &lt;!&ndash;                                          <strong > {{currency_with_symbol()}}</strong>&ndash;&gt;-->
<!--                        <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>-->
<!--                      </td>-->
<!--                      <td v-else style="text-align: right">-->
<!--                        <strong-->
<!--                            v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{-->
<!--                            get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)-->
<!--                          }}</strong>-->
<!--                      </td>-->

<!--                    </template>-->

<!--                  </CDataTable>-->
<!--                </CCol>-->
<!--              </CRow>-->

              <CRow>
                <CCol sm="4" md="4" style="text-align: start">
                  <h6>{{ $t('docCreator') }} : {{ my_branch_code() }}/{{ get_user_name() }}</h6>
                  <h6>Sign</h6>
                </CCol>
                <CCol sm="4" md="4" style="text-align: center">
                  <h6 class="pageFooter_no1"></h6>
                </CCol>
                <CCol sm="4" md="4" style="text-align: end">
                  <h6 v-if="selectedType==3">{{ $t('components.customer') }}</h6>
                  <h6 v-if="selectedType==1">{{ $t('buttons.seller') }}</h6>
                  <h6>Sign</h6>

                </CCol>
              </CRow>

            </CCardHeader>

          </div>
        </div>
        <div id="print_report_header" >
          <CCardHeader>
            <CRow>

              <CCol sm="4" md="4" style="text-align: right">
                <!--                  <h2 >{{ get_date(new Date()) }}</h2>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: center" >
                <!--                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>-->

<!--                <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
<!--                <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->
                <h6 style="font-weight: bold;" v-if="selectedType==7">{{ $t('buyFactorCurrency') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==1">{{ $t('components.buyDocument') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==0">{{ $t('PurchaseOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==0">{{ $t('SaleOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==1">{{ $t('factor') }}</h6>
<!--                <h6 style="font-weight: bold;" v-else>{{ $t('request_order') }}</h6>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: left">
                <!--                  <CImg :src="get_logo()" width="100px" height="50px"/>-->

              </CCol>
            </CRow>
            <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
              <CCol v-if="$i18n.locale=='en'" col="4">
                <table>

                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('request_order_no') }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>

              </CCol>
              <CCol v-if="$i18n.locale=='fa'" style="direction: initial" col="4">
                <table style="float:right">
                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('request_order_no') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>
              </CCol>

              <CCol col="8" class="text-left">

                <div>
                  <table style="float: left">
                    <tr>
                      <th style=";padding-top: 0;text-align: end" class="pr-2 pl-2">
                        <h6 class="m-0" style="font-weight: bold;font-size: 20px">{{
                            bissiness_profile.businessName
                          }}</h6>
                        <p class="m-0" v-if="bissiness_profile.vatNumber!=null && bissiness_profile.vatNumber!=''">{{$t('economicalCode')}} {{ bissiness_profile.vatNumber }}</p>
                        <p class="m-0" style="direction: ltr;text-align: left;">{{ company_address }}</p>
                        <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                        <p class="m-0" style="direction: ltr;float: left;"><span v-for="(phone_obj,index) in phone_objects" :key="'i'+index">{{ phone_obj.phone }} <span v-if="index != phone_objects.length-1"> - </span></span></p>
                        <p class="m-0">{{ email_objects[0].phone }}</p>
                      </th>
                      <th width="100px">
                        <CImg :src="get_logo()" width="100px" height="50px"/>
                      </th>
                    </tr>
                  </table>
                </div>

              </CCol>
            </CRow>
            <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">

            <CRow>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('billTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0"> {{ document_person }} </p>
                <!--                                <p>{{partyMobile}} </p>-->
                <p class="m-0" v-if="document_person_data.personAddress[0] !=null">
                  {{ document_person_data.personAddress[0].addressText }}
                  {{ document_person_data.personAddress[0].cityName }}
                  {{ document_person_data.personAddress[0].regionName }}
                  {{ document_person_data.personAddress[0].areaRelName }}

                </p>

                <p class="m-0"> {{ document_person_data.personAddress[0].postCode }}</p>
                <p class="m-0">{{ partyMobile }} </p>

              </CCol>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('shipTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null"> {{ document_person }} </p>

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].addressText }}
                  {{ document_person_data.personAddress[1].cityName }}
                  {{ document_person_data.personAddress[1].regionName }}
                  {{ document_person_data.personAddress[1].areaRelName }}
                </p>
<!--                <p class="m-0" v-else>-->
<!--                  {{ document_person_data.personAddress[0].addressText }}-->
<!--                  {{ document_person_data.personAddress[0].cityName }}-->
<!--                  {{ document_person_data.personAddress[0].regionName }}-->
<!--                  {{ document_person_data.personAddress[0].areaRelName }}-->
<!--                </p>-->

                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].postCode }}</p>
                <p class="m-0" v-if="document_person_data.personAddress[1] !=null">
                  {{ document_person_data.personAddress[1].phoneNo }}</p>

              </CCol>
            </CRow>
          </CCardHeader>

        </div>
        <div id="print_report_header_low" style="display: none">
          <CCardHeader>
            <CRow>

              <CCol sm="4" md="4" style="text-align: right">
                <!--                  <h2 >{{ get_date(new Date()) }}</h2>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: center">
                <!--                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>-->

<!--                <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
<!--                <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->
                <h6 style="font-weight: bold;" v-if="selectedType==7">{{ $t('buyFactorCurrency') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==1">{{ $t('components.buyDocument') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==1 && doc_status==0">{{ $t('PurchaseOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==0">{{ $t('SaleOrder') }}</h6>
                <h6 style="font-weight: bold;" v-if="selectedType==3 && doc_status==1">{{ $t('factor') }}</h6>
<!--                <h6 style="font-weight: bold;" v-else>{{ $t('request_order') }}</h6>-->

              </CCol>
              <CCol sm="4" md="4" style="text-align: left">
                <!--                  <CImg :src="get_logo()" width="100px" height="50px"/>-->

              </CCol>
            </CRow>
            <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
              <CCol v-if="$i18n.locale=='en'" col="4">
                <table>

                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: left"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('request_order_no') }}
                    </td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: left">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold;text-align: right">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>

              </CCol>
              <CCol v-if="$i18n.locale=='fa'" style="direction: initial" col="3">
                <table>
                  <tr v-if="doc_status!=0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('factor_no') }}</td>
                  </tr>
                  <tr v-if="doc_status==0">
                    <td style="font-weight: bold;text-align: right"> {{ doc_id_no }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('request_order_no') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(date) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('date') }}</td>
                  </tr>
                  <tr>
                    <td style="font-weight: bold;text-align: right">{{ get_date(payDueDate) }}</td>
                    <td class="pl-1 pr-1"> :</td>
                    <td style="font-weight: bold">{{ $t('payDueDate') }}</td>
                  </tr>
                </table>
              </CCol>
              <CCol col="2" v-if="$i18n.locale=='en'"></CCol>
              <CCol col="3" v-if="$i18n.locale=='fa'"></CCol>
              <CCol col="6" class="text-left">

                <div>
                  <table>
                    <tr>
                      <th style="width: 400px;padding-top: 0;text-align: end" class="pr-2 pl-2">
                        <h6 class="m-0" style="font-weight: bold">{{
                            bissiness_profile.businessName
                          }}</h6>
                        <p class="m-0" style="direction: ltr;text-align: left;">{{ company_address }}</p>
                        <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                        <p class="m-0">{{ phone_objects[0].phone }}</p>
                        <p class="m-0">{{ email_objects[0].phone }}</p>
                      </th>
                      <th width="100px">
                        <CImg :src="get_logo()" width="100px" height="50px"/>
                      </th>
                    </tr>
                  </table>
                </div>

              </CCol>
            </CRow>
            <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">

            <CRow>
              <CCol col="6" style="text-align: start">
                <label class="m-0" style="font-weight: bold">{{ $t('billTo') }}</label>
                <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
                <p class="m-0"> {{ document_person }} </p>
                <!--                                <p>{{partyMobile}} </p>-->
                <p class="m-0" v-if="document_person_data.personAddress[0] !=null">
                  {{ document_person_data.personAddress[0].addressText }}
                  {{ document_person_data.personAddress[0].cityName }}
                  {{ document_person_data.personAddress[0].regionName }}
                  {{ document_person_data.personAddress[0].areaRelName }}

                </p>

                <p class="m-0"> {{ document_person_data.personAddress[0].postCode }}</p>
                <p class="m-0">{{ partyMobile }} </p>

              </CCol>
            </CRow>
          </CCardHeader>

        </div>


        <CCard>


          <CCardBody id="printMe">
            <!--                        <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary-->
            <!--                            }} </p>-->
            <!--                        <hr v-if="document_summary!=null" class="mt-0">-->
            <div style="padding:3px;">
              <CDataTable
                  :items="product_items"
                  :fields="fields"
                  striped
                  border

                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">
                    <strong>{{ item.row_id + 1 }}</strong>

                  </td>

                </template>
                <template #name="{item}">
                  <td>
                    <strong>{{ item.productCode }} {{ item.productName }}</strong>
                  </td>
                </template>

                <template #unit="{item}">
                  <td>
                    <strong>{{ item.value }}</strong>
                  </td>
                </template>

                <template #qty="{item}">
                  <td style="text-align: right">
                    <strong  style="text-align: right">{{ get_currency((item.qty) / item.value,2) }}</strong>
                  </td>
                </template>
                <template #productUnitName="{item}">
                  <td >
                    <strong >{{item.productUnitName }}</strong>
                  </td>
                </template>
                <template #price="{item}">
                  <td>
                    <strong style="float: right">{{ get_currency(item.price) }} </strong>
                  </td>
                </template>
                <template #totalPrice="{item}">

                  <td>
                    <strong style="float: right">{{ get_currency(item.totalPrice) }} </strong>

                  </td>

                </template>
                <template #takhfif="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.takhfif)
                      }} </strong>

                  </td>

                </template>
                <template #tax="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.tax)
                      }} </strong>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <strong>{{ item.docDesc }}</strong>

                  </td>

                </template>


              </CDataTable>


            </div>
            <CCardBody class="mb-5">
              <CRow>
                <CCol col="7">
<p style="font-width: bold;" v-if="get_access('print_factor_description')">{{document_summary}}</p>
                  <p class="mb-1" v-for="(message,index) in messages_items" :key="'m'+index">{{ message.message }}</p>
                  <br>

                  <div style="bottom: 0;position: absolute;width: 100%;">
                    <hr class="m-0">

                    <p class="mb-1">{{selected_place}} | {{ $t('weightOfInvoice') }} {{ get_weight(total_weight) }} {{ $t('kg') }}</p>
                  </div>
                </CCol>
                <CCol col="5">

                  <CDataTable v-if="selectedType!=7"
                              :items="document_result_price"
                              :fields="fields_total_price"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                  <CDataTable v-if="selectedType==7"
                              :items="document_result_price"
                              :fields="fields_total_price_currency"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>
                    <template #resultPriceCurrency="{item}">
                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>
                      </td>
                      <td v-else style="text-align: right">
                        <strong
                                v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{
                          get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)
                          }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                </CCol>
              </CRow>

            </CCardBody>

          </CCardBody>
        </CCard>

        <CCard style="display: none">


          <CCardBody id="printMeLow">
            <!--                        <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary-->
            <!--                            }} </p>-->
            <!--                        <hr v-if="document_summary!=null" class="mt-0">-->
            <div style="padding:3px;border: 1px solid #000">
              <CDataTable
                  :items="product_items"
                  :fields="fields_low"
                  striped
                  border

                  :items-per-page="200"
                  hover
                  pagination
              >
                <template #row="{item}">

                  <td style="text-align: center">
                    <strong>{{ item.row_id + 1 }}</strong>

                  </td>

                </template>
                <template #name="{item}">
                  <td>
                    <strong>{{ item.productCode }} {{ item.productName }}</strong>
                  </td>
                </template>

                <template #unit="{item}">
                  <td>
                    <strong>{{ item.value }}</strong>
                  </td>
                </template>

                <template #qty="{item}">
                  <td style="text-align: right">
                    <strong style="text-align: right">{{ (item.qty) / item.value }}</strong>
                  </td>
                </template>
                <template #price="{item}">
                  <td>
                    <strong style="float: right">{{ get_currency(item.price) }} </strong>
                  </td>
                </template>
                <template #totalPrice="{item}">

                  <td>
                    <strong style="float: right">{{ get_currency(item.totalPrice) }} </strong>

                  </td>

                </template>
                <template #takhfif="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.takhfif)
                      }} </strong>

                  </td>

                </template>
                <template #tax="{item}">

                  <td>
                    <strong style="float: right">{{
                        get_currency(item.tax)
                      }} </strong>

                  </td>

                </template>
                <template #summary="{item}">

                  <td>
                    <strong>{{ item.docDesc }}</strong>

                  </td>

                </template>


              </CDataTable>
            </div>
            <CCardBody class="mb-5">
              <CRow>
                <CCol col="7">

                  <p class="mb-1" v-for="(message,index) in messages_items" :key="'j'+index">{{ message.message }}</p>
                  <br>

                  <div style="bottom: 0;position: absolute;width: 100%;">
                    <hr class="m-0">

                    <p class="mb-1">{{selected_place}} | {{ $t('weightOfInvoice') }} {{ get_weight(total_weight) }} {{ $t('kg') }}</p>
                  </div>
                </CCol>
                <CCol col="5">

                  <CDataTable v-if="selectedType!=7"
                              :items="document_result_price"
                              :fields="fields_total_price"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                  <CDataTable v-if="selectedType==7"
                              :items="document_result_price"
                              :fields="fields_total_price_currency"
                              striped
                              border
                              :responsive="false"
                              :items-per-page="200"
                              hover
                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>
                    <template #resultPriceCurrency="{item}">
                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>
                      </td>
                      <td v-else style="text-align: right">
                        <strong
                                v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{
                          get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)
                          }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                </CCol>
              </CRow>

            </CCardBody>

          </CCardBody>
          <CCardBody class="mb-5">
            <CRow>
              <CCol col="7">

                <p class="mb-1" v-for="(message,index) in messages_items" :key="'c'+index">{{ message.message }}</p>
                <br>

                <div style="bottom: 0;position: absolute;width: 100%;">
                  <hr class="m-0">
                  <p class="mb-1">{{selected_place}} |  {{ get_weight(total_weight) }} {{ $t('kg') }}</p>
                </div>
              </CCol>
              <CCol col="5">

                <CDataTable v-if="selectedType!=7"
                            :items="document_result_price"
                            :fields="fields_total_price"
                            striped
                            border
                            :responsive="false"
                            :items-per-page="200"
                            hover
                            pagination
                >
                  <template #resultTitle="{item}">

                    <td v-if="item.final_price" class="text-danger">
                      <strong>{{ item.resultTitle }}</strong>
                    </td>
                    <td v-else>
                      <strong>{{ item.resultTitle }}</strong>
                    </td>


                  </template>
                  <template #resultPrice="{item}">

                    <td style="text-align: right" v-if="item.final_price" class="text-danger">
                      <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                      <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                    </td>
                    <td style="text-align: right" v-else>
                      <!--                                          <strong > {{currency_symbol()}}</strong>-->
                      <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                    </td>

                  </template>

                </CDataTable>
                <CDataTable v-if="selectedType==7"
                            :items="document_result_price"
                            :fields="fields_total_price_currency"
                            striped
                            border
                            :responsive="false"
                            :items-per-page="200"
                            hover
                            pagination
                >
                  <template #resultTitle="{item}">

                    <td v-if="item.final_price" class="text-danger">
                      <strong>{{ item.resultTitle }}</strong>
                    </td>
                    <td v-else>
                      <strong>{{ item.resultTitle }}</strong>
                    </td>


                  </template>
                  <template #resultPrice="{item}">

                    <td style="text-align: right" v-if="item.final_price" class="text-danger">
                      <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                      <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                    </td>
                    <td style="text-align: right" v-else>
                      <!--                                          <strong > {{currency_symbol()}}</strong>-->
                      <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                    </td>

                  </template>
                  <template #resultPriceCurrency="{item}">
                    <td style="text-align: right" v-if="item.final_price" class="text-danger">

                      <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                      <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>
                    </td>
                    <td v-else style="text-align: right">
                      <strong
                          v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{
                          get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)
                        }}</strong>
                    </td>

                  </template>

                </CDataTable>
              </CCol>
            </CRow>

          </CCardBody>

        </CCard>

        <CCard id="printThermal" style="display: none">

          <div style="margin-top: 10px">
            <CCardHeader>
              <CRow>

<!--                <CCol sm="4" md="4" style="text-align: right">-->
<!--                  &lt;!&ndash;                  <h2 >{{ get_date(new Date()) }}</h2>&ndash;&gt;-->

<!--                </CCol>-->
<!--                <CCol sm="4" md="4" style="text-align: center">-->
<!--                  &lt;!&ndash;                                    <h2>{{types_parent.filter(x=>x.value ==selected_type_parent)[0].label}}</h2>&ndash;&gt;-->

<!--                  <p style="font-weight: bold;" v-if="doc_status!=0">{{ $t('factor') }}</p>-->
<!--                  <p style="font-weight: bold;" v-else>{{ $t('request_order') }}</p>-->

<!--                </CCol>-->
<!--                <CCol sm="4" md="4" style="text-align: left">-->
<!--                  &lt;!&ndash;                  <CImg :src="get_logo()" width="100px" height="50px"/>&ndash;&gt;-->

<!--                </CCol>-->
              </CRow>
              <CRow style="background-color: rgba(249,246,217,0.28);">
                <CCol col="12" class="text-center">

                  <div>
                    <h5 class="m-0" style="font-weight: bold">{{
                      bissiness_profile.businessName
                      }}</h5>
                    <p class="m-0" style="font-size: 12px;direction: ltr;text-align: center;;color: black">{{ company_address }}</p>

                    <p class="m-0" style="font-size: 12px;color: black">{{ phone_objects[0].phone }}</p>
<!--                    <p class="m-0">{{ email_objects[0].phone }}</p>-->

                  </div>

                </CCol>
                <CCol style="border-top:2px solid black;" col="12">
                  <CRow>
                    <CCol col="6"  style="font-size: 12px;color: black">{{ $t('factor_no') }} :</CCol>
                    <CCol col="6"  style="font-size: 12px;color: black">{{ doc_id_no }}</CCol>

                    <CCol col="6" style="font-size: 12px;color: black">{{ $t('date') }} :</CCol>
                    <CCol col="6" style="font-size: 12px;color: black">{{ get_date(date) }}</CCol>
                  </CRow>

                </CCol>

              </CRow>
<!--              <hr class="p-0 m-0" style="border-top: 2px solid rgb(0,0,0);">-->


            </CCardHeader>
          </div>

          <CCardBody class="mb-5" style="padding:0px!important;border-top:2px solid black;">
            <!--                        <p v-if="document_summary!=null">{{ $t('components.factorSummary') }}: {{ document_summary-->
            <!--                            }} </p>-->
            <!--                        <hr v-if="document_summary!=null" class="mt-0">-->
            <div style="padding:3px">

              <CDataTable
                  :items="product_items"
                  :fields="fields_thermal"


                  :items-per-page="200"

                  pagination
              >

                <template #name="{item}">
                  <td>
                    <p class="m-0" style="font-size: 12px">{{ item.productName }}</p>

                  </td>
                </template>


                <template #qty="{item}">
                  <td style="text-align: right">
                   <p class="m-0" style="text-align: center;font-size: 12px">{{ (item.qty) / item.value }}</p>

                  </td>
                </template>
                <template #price="{item}">
                  <td>
                    <p class="m-0" style="font-size: 12px">{{ get_currency(item.price) }} </p>

                  </td>
                </template>
                <template #totalPrice="{item}">

                  <td>
                    <p class="m-0" style="text-align: right;font-size: 12px">{{ get_currency(item.totalPrice) }} </p>
                  </td>

                </template>


              </CDataTable>

              <CRow>
                <CCol col="12">
                  <CDataTable v-if="selectedType!=7"
                              :items="document_result_price"
                              :fields="fields_total_price"
                              :responsive="false"
                              :items-per-page="200"
                              pagination
                  >
                    <template #resultTitle="{item}">


                      <td>
                        <p class="m-0" style="font-size: 12px;">{{ item.resultTitle }}</p>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" >
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <p class="m-0" style="text-align: right;font-size: 12px;">{{ currency_with_symbol(item.resultPrice) }}</p>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <p class="m-0" style="text-align: right;font-size: 12px;" v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</p>
                        <p class="m-0" style="text-align: right;font-size: 12px;" v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</p>
                      </td>

                    </template>

                  </CDataTable>
                  <CDataTable v-if="selectedType==7"
                              :items="document_result_price"
                              :fields="fields_total_price_currency"
                              :responsive="false"
                              :items-per-page="200"

                              pagination
                  >
                    <template #resultTitle="{item}">

                      <td v-if="item.final_price" class="text-danger">
                        <strong>{{ item.resultTitle }}</strong>
                      </td>
                      <td v-else>
                        <strong>{{ item.resultTitle }}</strong>
                      </td>


                    </template>
                    <template #resultPrice="{item}">

                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ currency_with_symbol(item.resultPrice) }}</strong>
                      </td>
                      <td style="text-align: right" v-else>
                        <!--                                          <strong > {{currency_symbol()}}</strong>-->
                        <strong v-if="item.currencyTitle=='Base'">{{ get_currency(item.resultPrice) }}</strong>
                        <strong v-if="item.currencyTitle!='Base'">{{ get_currency(item.resultPrice) }}</strong>
                      </td>

                    </template>
                    <template #resultPriceCurrency="{item}">
                      <td style="text-align: right" v-if="item.final_price" class="text-danger">
                        <!--                                          <strong > {{currency_with_symbol()}}</strong>-->
                        <strong>{{ item.resultPriceCurrencyTitle }} {{ get_currency(item.resultPriceCurrency) }}</strong>
                      </td>
                      <td v-else style="text-align: right">
                        <strong
                            v-if=" document_result_price_currency.filter(x=>x.resultTitle==item.resultTitle && x.currencyTitle!='Base').length>0">{{
                            get_currency(document_result_price_currency.filter(x => x.resultTitle == item.resultTitle && x.currencyTitle != 'Base')[0].resultPrice)
                          }}</strong>
                      </td>

                    </template>

                  </CDataTable>
                </CCol>
              </CRow>

            </div>
            <CRow>
              <CCol col="7"  ><p style="font-size: 12px;color: black">{{ $t('payDueDate') }} :</p></CCol>
              <CCol col="5"  ><p style="font-size: 12px;text-align: end;color: black">{{ get_date(payDueDate) }}</p></CCol>
            </CRow>
          </CCardBody>
          <CRow>
            <CCol col="12" style="text-align: start">

              <p class="mb-1" style="text-align: start;padding: 5px;font-size: 12px;color: black" v-for="(message,index) in messages_items" :key="'d'+index">{{
                  message.message
                }}</p>
              <br>

              <div style="bottom: 0;position: absolute;width: 100%;">
                <hr class="m-0">

                <p class="mb-1" style="color: black">{{selected_place}} | {{ $t('weightOfInvoice') }} {{ get_weight(total_weight) }} {{ $t('kg') }}</p>
              </div>
            </CCol>

          </CRow>
        </CCard>

      </CCol>
    </CRow>
    <CModal
        :title="$t('documentDoc')"
        color="dark"
        size="lg"
        :show.sync="pre_finalize"
    >
      <CRow>
        <CCol col="4"><label>{{ $t('docNumber') }}: 1</label></CCol>
        <CCol col="4"><label>{{ $t('documentDoc') }}</label></CCol>
        <CCol col="4"><label>{{ $t('docDate') }}</label></CCol>
      </CRow>
      <CRow>
        <CCol col="4"><label>{{ $t('docDescription') }}:</label></CCol>
        <CCol col="4"><label></label></CCol>
        <CCol col="4"><label>Page 1</label></CCol>
      </CRow>
      <CDataTable
          :items="pre_finalize_items"
          :fields="pre_finalize_fields"
          striped
          border
          :items-per-page="200"
          hover
          pagination
      >

        <template #under-table>
          <label></label>
          <br>
          <label>{{ $t('tanzimKonande') }}</label>
        </template>
      </CDataTable>

      <template #footer>
        <CButton @click="pre_finalize = false,finalize(false)" color="danger">{{ $t('buttons.ok') }}</CButton>
        <CButton @click="pre_finalize = false" color="danger">{{ $t('buttons.cancel') }}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import i18n from "../../../i18n";

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      payDueDate: '',
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: '',
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      pre_finalize: false,
      doc_id: '',
      doc_id_no: '',
      company_address: '',
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ], fields_low: [
        {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},
        {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},
      ],
      fields_thermal: [
        // {key: 'row', label: this.$t('tables.row'), sorter: false, _style: 'width:3%;padding:0px'},
        {key: 'qty', label: this.$t('tables.qty'), _style: 'padding:0px'},

        {key: 'name', label: this.$t('item'), _style: 'padding:0px'},
        // {key: 'productUnitName', label: this.$t('tables.unit'), _style: 'padding:0px'},
        // {key: 'price', label: this.$t('components.unitPrice'), _style: 'padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        {key: 'totalPrice', label: this.$t('tables.amount'), _style: 'padding:0px'},

        // {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],


      pre_finalize_items: [{
        tafzili: "9",
        moein: "8",
        kol: "12",
        account: "پرداخت هزینه سوخت",
        price_joz: "120000",

        price_bedehkar: "1000",
        price_bestankar: "1000"
      }, {
        tafzili: "",
        moein: "",
        kol: "",
        account: "",
        price_joz: this.$t('totalDoc'),
        price_bedehkar: "1000",
        price_bestankar: "1000"
      }],
      pre_finalize_fields: [
        {key: 'tafzili', label: this.$t('tafsili'), _style: 'width:3%;padding:0px'},
        {key: 'moein', label: this.$t('moein'), _style: 'width:3%;padding:0px'},
        {key: 'kol', label: this.$t('total'), _style: 'width:3%;padding:0px'},
        {key: 'account', label: this.$t('components.groupName'), _style: 'width:10%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price_joz', label: this.$t('subAmount'), _style: 'width:5%;padding:0px'},
        {key: 'price_bedehkar', label: this.$t('bedehkar'), _style: 'width:5%;padding:0px'},
        {key: 'price_bestankar', label: this.$t('bestankar'), _style: 'width:5%;padding:0px'},

      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],
      fields_total_price_currency: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px'},
        {key: 'resultPriceCurrency', label: this.$t('currency'), _style: 'padding:5px;'},
        {key: 'resultPrice', label: localStorage.getItem('currency_name'), _style: 'padding:5px;'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 0,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_data: {},
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',

      phone_objects: [],
      email_objects: [],
      website_objects: [],


      messages_items: [],
      person_email: [],

      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      total_weight: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      master_id: 0,
      document_result_price: [],
      document_result_price_currency: [],
      bissiness_profile: {},
      main_address: {},

    }
  }, mounted() {
    this.doc_id = this.$route.params.doc_id;
    this.$root.root_validate_errors = [];

    this.get_product_units();
    this.get_bussiness_profile();
    this.get_main_address();
    this.get_contact();


    bus.$on('delete_confirm_factor' + this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {

  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },

    'selectedType': function () {
      this.get_messages();

      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {

    finalize(to_print) {
      var self = this;
      const formData = new FormData();

      var url = "AddFactorToFinal_Adjustment";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          if(to_print){
            self.get_document_master("print");
          }else{
            self.get_document_master();
          }

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_contact() {
      var self = this;

      const formData = new FormData();

      axios.post('GetContactById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.phone_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.email_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.website_objects = [{phone_type: 19, phone: '', row_id: 1}]
          if (content_data.data.length) {
            self.phone_objects = []
            self.email_objects = []
            self.website_objects = []

          }
          content_data.data.forEach((val) => {
            if (val.contactType == 1) {
              self.phone_objects.push({phone: val.contactText});
            }
            if (val.contactType == 2) {
              self.email_objects.push({phone: val.contactText});

            }
            if (val.contactType == 3) {
              self.website_objects.push({phone: val.contactText});

            }


          });
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_product_units() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetProductUnits', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = content_data.data;
          self.get_document_master();


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    print() {
      // Pass the element id here
      // this.print_with_header_title('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no);
      this.print_with_header_title_height('printMe', 'print_report_header', 'print_report_footer', this.doc_id_no, 300, 350)

      // this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here
      console.log("edit called", this.selectedType);
      if (this.selectedType == 7) {
        // this.$router.push({path: "/dashboard/sale-orders/edit-sale-invoice/" + this.doc_id});
        this.$router.push({path: "/dashboard/orders/edit-currency-document/" + this.doc_id});

      }
      if (this.selectedType == 3) {
        this.$router.push({path: "/dashboard/sale-orders/edit-sale-invoice/" + this.doc_id});
        // this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});

      }
      if (this.selectedType == 1) {
        this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});

      }

    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master(print) {
      var self = this;


      const formData = new FormData();

      var url = "GetRecById";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          if (self.get_access("sale_hide_tax_off") && self.selectedType == 3) {
            self.fields.forEach(function (val, index) {
              if (val.key == 'tax') {
                self.fields.splice(index, 1);
              }
            });
            self.fields.forEach(function (val, index) {
              if (val.key == 'off') {
                self.fields.splice(index, 1);
              }
            });
          }

          self.selectedType = content_data.data.docType
          // self.document_person = content_data.data.partyName;
          self.document_person_id = content_data.data.partyId;
          self.date = content_data.data.docDate;
          self.selected_place = content_data.data.placeName;
          self.document_summary = content_data.data.docDesc;
          self.document_visitor = content_data.data.createdBy;
          self.document_driver = content_data.data.toziKonande;
          self.doc_status = content_data.data.statusId;
          self.tablo = content_data.data.tablo;
          self.address = content_data.data.addressText;
          self.vMobile = content_data.data.vMobile;
          self.partyMobile = content_data.data.partyMobile;
          self.doc_id_no = content_data.data.masterCode;
          document.title =  self.doc_id_no;

          self.tozikonandeMobile = content_data.data.tozikonandeMobile;
          self.payDueDate = content_data.data.payDueDate;
          // if (self.selectedType == 1) {
          //
          //   self.selectedTypeLabel = self.$t('components.seller');
          //   self.selectedTypeLabelRevert = self.$t('components.buyer');
          //   self.selectedTypeQty = 1;
          //   self.selectedTypeTitle = self.$t('components.documentBuy');
          // }
          // if (self.selectedType == 3) {
          //   self.selectedTypeLabel = self.$t('components.buyer');
          //   self.selectedTypeLabelRevert = self.$t('components.seller');
          //   self.selectedTypeQty = -1;
          //   self.selectedTypeTitle = self.$t('components.documentSell');
          //
          // }
          // if (self.selectedType == 5) {
          //   self.selectedTypeLabel = self.$t('components.employee');
          //   self.selectedTypeLabelRevert = self.$t('components.company');
          //   self.selectedTypeQty = 1;
          //   self.selectedTypeTitle = self.$t('components.documentFirst');
          //
          // }
          self.get_document_details(print);

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_result(print_op) {
      var self = this;


      const formData = new FormData();

      var url = "GetFactorResultByMasterId";

      formData.append("Id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          var total = 0;
          var total_currency = 0;
          var currency_title = '';
          var total_result_off = 0
          var total_result_off_currency = 0
          var currency_title = 0
          //*********************8 merge result
          if (self.get_access("merge_price_result")) {
            content_data.data.factorResults.filter(x=> (x.resultItemId==4 || x.resultItemId==5) && x.currencyTitle=="Base"  ).forEach(function (val) {
                total_result_off+= parseFloat(val.resultPrice.replace(/,/g, ""));
            })

          content_data.data.factorResults.filter(x=> (x.resultItemId==4 || x.resultItemId==5) && x.currencyTitle!="Base"  ).forEach(function (val) {
            total_result_off_currency+= parseFloat(val.resultPrice.replace(/,/g, ""));
            currency_title=val.currencyTitle;
            })
            content_data.data.factorResults = content_data.data.factorResults.filter(x=> x.resultItemId!=4 && x.resultItemId!=5 && x.resultItemId!=6 ) ;
          }
          //*********************8 end merge result

          self.document_result_price = [];
          total = parseFloat(content_data.data.factorResults.filter(x => x.resultItemId == 8 && x.currencyTitle == 'Base')[0].resultPrice.replace(/,/g, ""));
          if (self.selectedType == 7) {
            total_currency = parseFloat(content_data.data.factorResults.filter(x => x.resultItemId == 8 && x.currencyTitle != 'Base')[0].resultPrice.replace(/,/g, ""));
          }
          content_data.data.factorResults = content_data.data.factorResults.filter(x => x.resultItemId != 8);

          content_data.data.factorResults.forEach((val) => {

            val.resultPrice = val.resultPrice.replace(/,/g, "")
            self.document_result_price.push(val);
            if (self.get_access("merge_price_result") && val.resultItemId==3 && total_result_off>0) {
              self.document_result_price.push({currencyTitle: "Base", resultTitle: self.$t('Discounts'), resultPrice: total_result_off, resultItemId: 4});
            }
            if (self.get_access("merge_price_result") && val.resultItemId==3 && total_result_off_currency>0) {
              self.document_result_price.push({currencyTitle: currency_title, resultTitle: self.$t('Discounts'), resultPrice: total_result_off, resultItemId: 4});
            }

            if (val.currencyTitle == 'Base') {
            } else {
              currency_title = val.currencyTitle;
            }
            total_result_off=0;
            total_result_off_currency=0;
          });
          //********* check costs
var total_cost_price = 0;
var total_cost_price_currency = 0;
var total_cost_price_title = 0;
          content_data.data.factorCosts.forEach((val) => {
            val.resultPrice = val.resultPrice.replace(/,/g, "")
            if (!self.get_access("merge_price_result")) {

              self.document_result_price.push(val);
              if (val.currencyTitle == 'Base') {
                total += parseInt(val.resultPrice.replace(/,/g, ""));
              } else {
                total_currency += parseInt(val.resultPrice.replace(/,/g, ""));
              }
            } else {
              if (val.currencyTitle == 'Base') {
                total_cost_price += parseFloat(val.resultPrice.replace(/,/g, ""));

                total += parseFloat(val.resultPrice.replace(/,/g, ""));
              } else {
                total_cost_price_currency += parseFloat(val.resultPrice.replace(/,/g, ""));
                total_cost_price_title = (val.currencyTitle);

                total_currency += parseFloat(val.resultPrice.replace(/,/g, ""));
              }
            }
          });
          if (self.get_access("merge_price_result") && total_cost_price>0) {
            self.document_result_price.push({currencyTitle: "Base", resultTitle:self.$t('Costs'), resultPrice: total_cost_price, resultItemId: 1});
            if (self.selectedType == 7) {
              self.document_result_price.push({currencyTitle: total_cost_price_title, resultTitle:self.$t('Costs'), resultPrice: total_cost_price_currency, resultItemId: 1});
            }
          }
//***********************************


          var obj = {
            currencyTitle: 'Base',
            final_price: true,
            resultTitle: self.$t('factorTotalPrice'),
            resultPrice: total,
            resultPriceCurrency: total_currency,
            resultPriceCurrencyTitle: currency_title,
          }
          self.document_result_price.push(obj);

          if (self.selectedType == 7) {
            self.document_result_price_currency = JSON.parse(JSON.stringify(self.document_result_price));
            self.document_result_price = self.document_result_price.filter(x => x.currencyTitle == "Base");

          }

          self.get_user_data();


          if (print_op != null) {
            self.print();
          }


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details(print) {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.product_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });
          self.total_weight = 0;
          self.product_items.forEach((val) => {
            // console.log("total weight is ",val.docWeight,val.qty,val.value)
            self.total_weight += val.docWeight * val.qty;
            if(self.selectedType==3){
              val.price = val.price*val.value

            }
            val.takhfif = val.discount
          });
          self.total_weight = self.total_weight / 1000;

          self.get_document_result(print);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor' + this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        self.$router.go(-1)

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    get_messages() {
      var self = this;

      const formData = new FormData();

      formData.append('DocTypeId', this.selectedType);


      axios.post('message/GetData', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.messages_items = content_data.data.filter(x => x.docTypeId == self.selectedType);

        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },

    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {
        //
        var person = res.data.data.person;

        self.document_person = person.personCode
        self.document_person += " " + person.personName
        if (person.middelName != null) {
          self.document_person += " " + person.middelName
        }
        if (person.surName != null) {
          self.document_person += " " + person.surName
        }
        // self.document_person_remain_amount = res.data.data.mande;

        // var tota_price = self.document_result_price[self.document_result_price.length - 1].resultPrice;
        // tota_price = tota_price.replaceAll(",", "");

        // var  obj = {resultTitle: "مانده از قبل", resultPrice: res.data.data.mande.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")};
        // tota_price = parseInt(res.data.data.mande) + parseInt(tota_price)
if(res.data.data.personContacts.filter(x => x.contactType == 18).length>0){
  self.person_email = res.data.data.personContacts.filter(x => x.contactType == 18)[0].contact

}
        // console.log("person email is ",self.person_email);
        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };
        // self.document_result_price.push(obj)

        self.document_person_data = res.data.data;

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    get_bussiness_profile() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.bissiness_profile_id);


      axios.post('GetProfileById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bissiness_profile = content_data.data
          self.previewImage = localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo
          localStorage.setItem("app_logo", localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo)
          document.getElementById("logo_image").src = localStorage.getItem("app_logo")
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_main_address() {
      var self = this;

      const formData = new FormData();


      axios.post('GetAddressById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.main_address = content_data.data

          if (self.$i18n.locale == 'fa') {
            self.company_address = self.main_address.cityName + " " + self.main_address.street + " " + self.main_address.houseNO + " " + self.main_address.postCode;

          } else {
            self.company_address = self.main_address.houseNO + " " + self.main_address.street + " " + self.main_address.cityName + " " + self.main_address.postCode;

          }


        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

  }

}

</script>
